
import React from 'react';
import { Tooltip } from 'antd';
import { get, has, includes } from 'lodash';
import styled from 'styled-components';
import { productPickingType, getItemQuantity, getStatusCode } from '../../../utils/misc';
import OrderItemManager from './OrderItemManager';
import {
    Icon,
    Number,
    Text,
    HasPermissions,
    StatusTag,
    Row,
    Column,
    ProductPrice,
    AppIcon,
    ConditionalRender,
    FlexContainer
} from '../../common';

const pendingPickingValues = getStatusCode('Pendiente picking');
const enPickingValues = getStatusCode('En picking');



const ClickableLink = styled.a`
    color: black;
`;

let colorChange = '#4cb358';

const _renderCell = (item, dataIndex) => (get(item, dataIndex, '-'));

const renderWithPriceFormatter = (item, dataIndex) => {
    const value = _renderCell(item, dataIndex);
    return (
        <div style={{ textAlign: 'right' }}>
            <span>
                <Number value={value} />
            </span>
        </div>
    );
};

const renderCellProduct = (item, dataIndex, onRowClick) => {
    const isUpselling = get(item, 'isUpselling')
    const status = productPickingType(get(item, 'status', get(item, 'picking.status', 'default')));
    const showPickingEan = includes(['partial-picking', 'picked'], status);

    return <div>
        <HasPermissions
            to={['order-detail-page:product-detail-drawer']}
            otherwise={<p className='truncate' style={{ width: 210 }}>{get(item, dataIndex)}</p>}>
            <ClickableLink onClick={(e) => { e.preventDefault(); onRowClick(item); }}>
                <Row gap={3} algin='center'>
                    <p className='truncate' style={{ width: 210, color: colorChange, flex: 1 }}>{get(item, dataIndex)}</p>
                    {isUpselling && <Tooltip placement='top' title='Producto agregado por upselling'>
                        <AppIcon name='ic-cart-plus' style={{ marginRight: '3px', fontSize: '11px' }} fill='#166DC2' />
                    </Tooltip>}
                </Row>
                <FlexContainer mY={5} align='center'>
                    <Icon name='barcode' color='#666666' size={15} right={5} />
                    <Text text={get(item, showPickingEan ? 'picking.ean' : 'ean', 'No Disponible')} color='#666666' size={11} lineHeight={1} />
                </FlexContainer>
            </ClickableLink>
        </HasPermissions>
        <ConditionalRender condition={has(item, 'priceTags.0.rateAndBenefit.name')}>
            <FlexContainer align='center'>
                <Icon name='descuento' color='#666666' size={13} right={5} />
                <Text text={get(item, 'priceTags.0.rateAndBenefit.name')} color='#666666' size={11} />
            </FlexContainer>
        </ConditionalRender>
    </div>;
};

const getPickingResult = (item, dataIndex) => {
    if (get(item, 'status') === 'ADDED_BY_CLIENT') {
        const quantity = get(item, 'pickingQuantity', '0');
        const measureUnit = get(item, 'unit', 'un');
        const valueToShow = measureUnit === 'kg' ? parseFloat(quantity).toFixed(3) : quantity;
        return `${(String(valueToShow).replace('.', ','))} ${measureUnit}`;
    }
    const status = get(item, 'picking.status');
    const shouldHide = ['FREE_PICKING_ACCEPTED', 'SUBSTITUTE_CONFIRMED'];
    const quantity = get(item, dataIndex, '0');
    const measureUnit = get(item, 'unit', 'un');
    const value = get(item, dataIndex);
    const valueToShow = measureUnit === 'kg' ? parseFloat(value).toFixed(3) : value;
    if (String(quantity) === '0' || shouldHide.includes(status)) return _renderCell(null, null);
    return `${(String(valueToShow).replace('.', ','))} ${measureUnit}`;
};

const initialColumns = [
    {
        title: 'Solicitado',
        width: '71px',
        dataIndex: 'quantity',
        key: 'quantity',
        render: (item,  dataIndex, parentProps, lastKnownStatus) => {
            const statusOrder = get(lastKnownStatus, 'code', '0')
            const status = get(item, 'status');
            if (status === 'ADDED_BY_CLIENT') return '-';
            console.log("statusOrder", statusOrder)
            return (
                (pendingPickingValues.includes(String(statusOrder)) || enPickingValues.includes(String(statusOrder))) ?
                <HasPermissions to={['order-detail-page:view-quantity']} otherwise="-">
                    {getItemQuantity(item)}
                </HasPermissions>
            :
                getItemQuantity(item)
            );
            
        }
    },
    {
        title: 'Resultado picking',
        width: '127px',
        dataIndex: 'picking.pickingQuantity',
        key: 'picked',
        render: (item, dataIndex) => {
            return getPickingResult(item, dataIndex);
        }
    },
    {
        title: 'Estado',
        width: '145px',
        dataIndex: 'status',
        key: 'status',
        render: (item, dataIndex) => {
            const status = productPickingType(get(item, 'status', get(item, 'picking.status', 'default')));
            return (
                <FlexContainer pX={5} minWidth={120} backgroundColor='#ffffff'>
                    <StatusTag dot mL={0} key={dataIndex} status={`order_detail.item.picking.status.${status}`} tagType={status} />
                </FlexContainer>
            );
        }
    },
    {
        title: 'Producto',
        width: '210px',
        dataIndex: 'name',
        key: 'product',
        render: (item, dataIndex, { onRowClick }) => {
            return renderCellProduct(item, dataIndex, onRowClick);
        }
    },
    {
        title: 'Marca',
        width: '133px',
        dataIndex: 'brandName',
        key: 'brandName',
        render: (item, dataIndex) => <Text text={get(item, dataIndex, '')} size={11} />
    },
    {
        title: 'Comentario',
        dataIndex: 'customerNotes',
        render: (item, dataIndex) => {
            const isUnit = get(item, 'isUnit');
            const isGift = get(item, 'isGiftCencosud');
            return (
                <FlexContainer style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <ConditionalRender condition={get(item, dataIndex)}>
                        <FlexContainer>
                            <Tooltip placement='top' title={get(item, dataIndex)}>
                                <AppIcon name='ic-voice' style={{ marginRight: '10px', fontSize: '11px' }} fill='#4cb358' />
                            </Tooltip>
                        </FlexContainer>
                    </ConditionalRender>
                    <ConditionalRender condition={isUnit}>
                        <FlexContainer>
                            <Tooltip placement='top' title={<div style={{ textAlign: 'center' }}>producto pesable<br />recolectado por unidad</div>}>
                                <AppIcon name='icono-unidad' style={{ marginRight: '10px', fontSize: '11px' }} fill='#4cb358' />
                            </Tooltip>
                        </FlexContainer>
                    </ConditionalRender>
                    <ConditionalRender condition={isGift}>
                        <FlexContainer>
                            <Tooltip placement='top' title={'Producto solicitado como regalo'}>
                                <AppIcon name='gift' style={{ marginRight: '5px', fontSize: '11px' }} fill='#4cb358' />
                            </Tooltip>
                        </FlexContainer>
                    </ConditionalRender>
                </FlexContainer>
                
            );
        }
    },
    {
        title: 'Precio unitario (uni /kg)',
        dataIndex: 'basePrice',
        key: 'client',
        render: item => <ProductPrice item={item} />,
        width: '114px'
    },
    {
        title: 'Total solicitado',
        width: '108px',
        dataIndex: 'sellingPrice',
        key: 'sale_price',
        render: (item, dataIndex) => {
            const status = get(item, 'status');
            const { quantity = 0 } = item;
            return (
                <div>
                    <span>
                        { status === 'ADDED_BY_CLIENT' ? '-' : <Number value={get(item, dataIndex) * parseFloat(quantity)} /> }
                    </span>
                </div>
            );
        }
    },
    {
        title: 'Total pickeado',
        width: '104px',
        dataIndex: 'picking',
        key: 'final_price',
        render: (item, dataIndex) => {
            const isAdded = get(item, 'status') === 'ADDED_BY_CLIENT';
            const data = isAdded ? item : get(item, dataIndex, {});
            const { sellingPrice, pickingQuantity, unitMultiplier } = data;
            const value = parseInt(sellingPrice) * (parseFloat(pickingQuantity) / parseFloat(unitMultiplier));
            return (
                <div>
                    <span>
                        { value > 0 ? <Number value={value} style={{ fontWeight: 'bold' }} /> : '-' }
                    </span>
                </div>
            );
        }
    },
    {
        title: '',
        dataIndex: 'isDeleted',
        key: 'is_deleted',
        render: (item, dataIndex, { orderId, removeOptionEnabled, lastKnownStatus, salesChannelId }) => {
            return (
                !includes(['UNPICK_ADDED_BY_CLIENT'], get(item, 'picking.status')) &&
                removeOptionEnabled &&
                get(lastKnownStatus, 'code') !== '41' &&
                <OrderItemManager data={item} orderId={orderId} salesChannelId={salesChannelId} />
            );
        }
    }
];

export const splitColumns = [
    {
        title: 'Solicitado',
        width: '71px',
        dataIndex: 'quantity',
        key: 'quantity',
        render: (item, dataIndex) => getItemQuantity(item)
    },
    {
        title: 'Resultado picking',
        width: '127px',
        dataIndex: 'picking.splitQuantity',
        key: 'picked',
        render: (item, dataIndex) => {
            const lastKnownStatusCode = get(item, 'lastKnownStatus.code');
            const isPending = includes(['1', '2', '20', '3', '7', '34'], lastKnownStatusCode);
            return isPending ? '-' : get(item, 'picking.splitQuantity');
        }
    },
    {
        title: 'Estado',
        width: '145px',
        dataIndex: 'status',
        key: 'status',
        render: (item, dataIndex) => {
            const splitStatus = get(item, 'picking.splitStatus');
            const lastKnownStatusCode = get(item, 'lastKnownStatus.code');
            const isPending = includes(['1', '2', '20', '3', '7', '34'], lastKnownStatusCode);

            const getTextStatus = () => {
                if (isPending) return 'Pendiente';

                switch (splitStatus) {
                    case 1:
                      return 'Encontrado';
                    case 2:
                      return 'Encontrado parcial';
                    default:
                      return 'No encontrado';
                }
            };

            const getTagType = () => {
                if (isPending) return 'pending';
                if (splitStatus === 1) return 'found';
                if (splitStatus === 2) return 'found-partial';
                return 'not-found';
            };

            return (
                <FlexContainer pX={5} minWidth={120} backgroundColor='#ffffff'>
                    <StatusTag dot mL={0} key={dataIndex} status={getTextStatus()} tagType={getTagType()} />
                </FlexContainer>
            );
        }
    },
    {
        title: 'Producto',
        width: '210px',
        dataIndex: 'name',
        key: 'product',
        render: (item, dataIndex, { onRowClick }) => {
            return renderCellProduct(item, dataIndex, onRowClick);
        }
    },
    {
        title: 'Marca',
        width: '133px',
        dataIndex: 'brandName',
        key: 'brandName',
        render: (item, dataIndex) => <Text text={get(item, dataIndex, '')} size={11} />
    },
    {
        title: 'Splitero',
        width: '104px',
        dataIndex: 'nameSpliter',
        key: 'nameSpliter',
        render: (item, dataIndex) => <Text text={get(item, dataIndex, '')} size={11} />
    }
];

export const substitutionColumns = [
    { title: 'empty', render: () => (null) },
    {
        title: '',
        dataIndex: 'pickingQuantity',
        key: 'picked',
        render: (item, dataIndex) => {
            const measureUnit = (get(item, 'unit', 'un')).toLowerCase();
            const value = get(item, dataIndex);
            const valueToShow = measureUnit === 'kg' ? parseFloat(value).toFixed(3) : value;
            return `${(String(valueToShow).replace('.', ','))} ${measureUnit}`;
        }
    },
    {
        title: '',
        dataIndex: 'arrow',
        key: 'arrow',
        render: () => (
            <FlexContainer justify='center'>
                <Row>
                    <Column>{null}</Column>
                    <Column flex={2} align='flex-start'>
                        <AppIcon name='ic-replace' size='22' />
                    </Column>
                    <Column>{null}</Column>
                </Row>
            </FlexContainer>
        )
    },
    {
        title: 'Producto',
        dataIndex: 'name',
        key: 'product',
        render: (item, dataIndex, { onRowClick, parent }) => (
            <div>
                <HasPermissions
                    to={['order-detail-page:product-detail-drawer']}
                    otherwise={<p className='truncate' style={{ width: 210 }}>{get(item, dataIndex)}</p>}>
                    <ClickableLink onClick={(e) => { e.preventDefault(); onRowClick(parent); }}>
                        <p className='truncate' style={{ width: 210, color: colorChange }}>{get(item, dataIndex, dataIndex)}</p>
                        <FlexContainer mY={5} align='center'>
                            <Icon name='barcode' color='#666666' size={15} right={5} />
                            <Text text={get(item, 'ean', 'No Disponible')} color='#666666' size={11} lineHeight={1} />
                        </FlexContainer>
                    </ClickableLink>
                </HasPermissions>

            </div>
        )
    },
    {
        title: 'Marca',
        dataIndex: 'brandName',
        key: 'brandName',
        render: (item, dataIndex) => <Text text={get(item, dataIndex, '')} size={11} />
    },
    { title: 'empty', render: () => (null) },
    {
        title: 'Precio unitario',
        dataIndex: 'sellingPrice',
        key: 'list_price',
        render: renderWithPriceFormatter
    },
    {
        title: '  Total solicitado',
        dataIndex: 'sellingPrice',
        key: 'sale_price',
        render: () => (null)
    },
    {
        title: 'Total pickeado',
        dataIndex: 'sellingPrice',
        key: 'final_price',
        render: (item, dataIndex) => {
            const value = parseInt(get(item, dataIndex)) * parseFloat(get(item, 'pickingQuantity'));
            return (
                <span>
                    { value > 0 ? <Number value={value} style={{ fontWeight: 'bold' }} /> : '-' }
                </span>
            );
        }
    },
    { title: 'empty', render: () => (null) }
];

export default initialColumns;
